import React, { useContext } from "react";
import AccordionContext from "react-bootstrap/AccordionContext";

const OperationsAccordionHeader = ({ children, eventKey, onClick, className = "" }) => {
  const currentEventKey = useContext(AccordionContext);
  const isOpen = currentEventKey === eventKey;

  return (
    <div
      className={`operations-page__accordion-header ${
        isOpen ? "is-open" : ""
      } ${className}`.trim()}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          onClick(event);
        }
      }}
    >
      <span className="operations-page__accordion-title">{children}</span>
      <span className="operations-page__accordion-icon" aria-hidden="true">
        <i className={`fa fa-chevron-${isOpen ? "up" : "down"}`} />
      </span>
    </div>
  );
};

export default OperationsAccordionHeader;
